import { useState, useEffect } from "react";
import { duplicateProps } from "../../../refractCommon/miro/duplicateProps";
import { createItem } from "../../../refractCommon/miro/create";
import { removeHtml } from "../../../refractCommon/removeHtml";
import { sortLeftRightTopBottom } from "../../../refractCommon/miro/sortLeftRightTopBottom";
import ToolWrapper from "../../PowerPack_Common/ToolWrapper";
import { runFilterOrderValidateSelectedItems } from "../../Utils/runFilterOrderValidateSelectedItems";

const miro = window.miro;

const toolConfig = {
  tool_name: "Table of Contents",
  tool_icon: "bullet-list",
  tool_short_description: "Create a table of contents linking to several objects",
  tool_id: "table-of-contets",
  works_on: "many to one",
  tool_type_icons: (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-text cs3"></div>
      <div className="m2 icon icon-frame cs4"></div>
    </div>
  ),
  tool_is_in_uat: false,
  tool_is_pro: false,
};

// SELECTION STUFF
let itemValidator = {
  validItemTypes: ["sticky_note", "text", "shape", "frame"],
  source_min: 1,
  source_max: 20,
};

export default function TableOfContents({ boardSelection, userIsPro, environment }) {

  useEffect(() => {
    // let validSelectItems = runFilterOrderValidateSelectedItems(
    //   boardSelection,
    //   itemValidator.validItemTypes
    // );
    // setSelectedValidItems(validSelectItems);
  }, [boardSelection]);


  function merge(items, delimiter) {
    let htmlContent;
    if (items.length >= 2) {
      let delim = delimiter || " ";
      let finalStringArray = [];
      items.forEach((item) => finalStringArray.push(removeHtml(item.content)));
      let finalString = finalStringArray.join(delim);
      htmlContent = "<p class='p-small'>" + finalString + "</a></p>";
      return htmlContent;
    }
  }

  async function createTableOfContents() {
    let items = runFilterOrderValidateSelectedItems(
      await miro.board.getSelection(),
      itemValidator.validItemTypes
    );

    if (items.length < 1) return;
    let content = "";
    const boardId = (await miro.board.getInfo()).id
    sortLeftRightTopBottom(items);
    for (const item of items) {
      let itemName = item.content || item.title || item.type;
      itemName = removeHtml(itemName);
      content += `<p><a href="https://miro.com/app/board/${boardId}/?moveToWidget=${item.id}">${itemName}</a></p>`
    }
    console.log("content", content);
    const viewport = await miro.board.viewport.get();
    const miroItem = await miro.board.createStickyNote({
      x: viewport.x + viewport.width / 2,
      y: viewport.y + viewport.height / 2,
      width: viewport.width * .2,
      style: {
        fillColor: 'gray',
        textAlign: 'left',
        textAlignVertical: 'top',
      },
      content: content,
    })

    // miroItem.content = content + '..';
    // // miroItem.height = miroItem.height * items.length
    // miroItem.width = 201
    // await miroItem.sync();

    // let items = validSelectedSourceItems;
    // let targetItem = validSelectedTargetItem[0];
    // if (items.length > 2) {
    //   let delim = " | ";
    //   let finalStringArray = [];
    //   items.forEach((item) => finalStringArray.push(removeHtml(item.content)));
    //   let finalString = finalStringArray.join(delim);
    //   let htmlContent = "<p class='p-small'>" + finalString + "</p>";
    //   targetItem.content = htmlContent;
    //   targetItem.sync();
    // }
  }

  return (
    <ToolWrapper
      toolConfig={toolConfig}
      boardSelection={boardSelection}
      userIsPro={userIsPro}
      environment={environment}>
      <div className="cs1 ce12 p-medium mt-0">
        {toolConfig.tool_short_description}
        <div className="help-container grid cs1 ce12 mt-8 mb-0 pt-8">
          <p className="p-small cs1 ce4 mb-0 mt-0">
            Works on{" "}
            <b>
              {toolConfig.works_on.length < 5 ? (
                <span>{toolConfig.works_on}</span>
              ) : (
                <span>
                  <br />
                  {toolConfig.works_on}
                </span>
              )}
            </b>
          </p>
          {toolConfig.tool_type_icons}
        </div>
      </div>
      <div className="grid cs1 ce12 ">
        <div className="cs1 ce6 mb-0"></div>

        <div className="cs1 ce12 form-group mb-0 grid mt-0">
          <button
            type="button"
            className="button button-primary button-small cs1 ce12 mb-0 mt-0"
            onClick={createTableOfContents}>
            Create Table of Contents
          </button>
        </div>
      </div>
    </ToolWrapper>
  );
}
